import React from "react"
import {
    Alignment,
    AnchorButton,
    H3,
    Intent,
    Navbar,
    NavbarDivider,
    NavbarGroup,
    NavbarHeading,
} from "@blueprintjs/core"
import {useKeycloak} from "@react-keycloak/web"
import {useSelector} from "react-redux"
import {ReactComponent as Logo} from "../../images/biocrates_Logo_15mm_RGB.svg"

import isInternOnly from "../selectors/core.selector"
import licenceService from "../../metstat/components/LicenceService"
import env from "../../context/Env"
import AvatarMenu from "../../@biocrates-common-repo/core/components/avatar/AvatarMenu"

export default function NavBar() {
    const {keycloak} = useKeycloak()
    const internOnly = useSelector(isInternOnly)
    const getUserName = () => {
        if (
            keycloak &&
            keycloak.tokenParsed &&
            "name" in keycloak.tokenParsed
        ) {
            const {name} = keycloak.tokenParsed
            return name
        }
        return "Loading..."
    }

    const getEmail = () => {
        if (
            keycloak &&
            keycloak.tokenParsed &&
            "email" in keycloak.tokenParsed
        ) {
            const {email} = keycloak.tokenParsed
            return email
        }
        return "Loading..."
    }

    const redirect = () => {
        window.open(env("INVALID_LICENSE_URL"), "_blank", "noopener,noreferrer")
    }

    return (
        <Navbar className="AppnameAndAvatar">
            <NavbarGroup align={Alignment.LEFT}>
                <NavbarHeading>
                    <Logo width="200" />
                </NavbarHeading>
                <NavbarDivider />
                {!internOnly && (
                    <H3 className="no-margin ModuleBarElement">
                        Quantitative metabolomics database
                    </H3>
                )}
            </NavbarGroup>
            <NavbarGroup align={Alignment.RIGHT}>
                {licenceService.willExpire() && (
                    <AnchorButton
                        intent={Intent.WARNING}
                        text={`Your QMDB subscription is about to expire in less than ${env(
                            "LICENCE_WILL_EXPIRE_AFTER_DAYS"
                        )} days.`}
                        className="action-button CardRowElement ag-row-selected"
                        icon="warning-sign"
                        onClick={redirect}
                    />
                )}
                <AvatarMenu
                    fullName={getUserName()}
                    email={getEmail()}
                    logout={() => keycloak.logout()}
                    settings={{isAccountWindowOpen: true}}
                />
            </NavbarGroup>
        </Navbar>
    )
}
